import { FC, useState, memo } from 'react';
import { Tab, Tabs } from '@mui/material';
import ItemDetailAvailability from './ItemDetailAvailability';
import { GridDetailRowProps } from '@progress/kendo-react-grid';
import ItemDetailOnOrder from './ItemDetailOnOrder';
import ItemDetailHistory from './ItemDetailHistory';
import ItemDetailInfo from './ItemDetailInfo';

const ItemDetail: FC<React.PropsWithChildren<GridDetailRowProps>> = ({ dataItem }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const onTabIndexChanged = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div>
      <Tabs value={tabIndex} onChange={onTabIndexChanged}>
        <Tab id="item-availability-tab" label="Availability"></Tab>
        <Tab id="on-order-tab" label="On Cust SO"></Tab>
        <Tab label="History"></Tab>
        <Tab label="Item Details"></Tab>
      </Tabs>
      <ItemDetailAvailability
        visible={tabIndex == 0}
        itemNumber={dataItem.itemNumber}
        sfaOrder={dataItem.sfaOrderId}
        orderNumber={dataItem.orderNumber}
        orderSuffix={dataItem.orderSuffix}
      />
      {tabIndex == 1 && <ItemDetailOnOrder visible={tabIndex == 1} itemNumber={dataItem.itemNumber} itemName={dataItem.description} />}
      {tabIndex == 2 && <ItemDetailHistory visible={tabIndex == 2} itemNumber={dataItem.itemNumber} itemName={dataItem.description} />}
      {tabIndex == 3 && <ItemDetailInfo visible={tabIndex == 3} itemNumber={dataItem.itemNumber} itemWeight={dataItem.itemWeight} />}
    </div>
  );
};

export default memo(ItemDetail);
